import { ApiUtil as api } from '@/utils/api.util.js'

export class OrderOperationClaimLineService {
  static URL = process.env.API_URL + process.env.API_VER
  static PARENT_RESOURCE = '/order-operations/'
  static RESOURCE = '/claim-lines/'

  static all (orderOperationId, queryParams = {}) {
    return api.get(this.URL + this.PARENT_RESOURCE + orderOperationId + this.RESOURCE, queryParams)
  }

  static create (orderOperationId, queryParams = {}) {
    return api.post(this.URL + this.PARENT_RESOURCE + orderOperationId + this.RESOURCE, queryParams)
  }

  static update (orderOperationId, id, queryParams = {}) {
    return api.put(this.URL + this.PARENT_RESOURCE + orderOperationId + this.RESOURCE + id, queryParams)
  }

  static updateClaimLine (id, queryParams = {}) {
    return api.put(this.URL + this.PARENT_RESOURCE + 'claim-lines/' + id, queryParams)
  }

  static delete (orderOperationId, id) {
    return api.delete(this.URL + this.PARENT_RESOURCE + orderOperationId + this.RESOURCE + id)
  }

  static void (orderOperationId, id, queryParams = {}) {
    return api.put(this.URL + this.PARENT_RESOURCE + orderOperationId + this.RESOURCE + id + '/void', queryParams)
  }

  static mappedIds (queryParams = {}) {
    return api.get(this.URL + '/order-operation-claim-lines/mapped-ids', queryParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/orderOperationClaimLine.service.js